/* hl-blog-img-pdp — a tap on a photo in an article goes to the product.
 *
 * WHY (2026-09-26)
 * Readers tap article photos expecting them to lead somewhere. In September
 * the unlinked ones (the hero image-block and the <p><img class="hl-r"> photos
 * inside the post) collected dead clicks, and 822 blog sessions produced 0 add
 * to carts. The owner asked for a tap on a blog photo to open that product's
 * page, tagged so the visit can be counted.
 *
 * WHICH PRODUCT
 * 1. A photo already inside a /products/ link keeps its link; only the UTM is
 *    added, at tap time, so the HTML links (and what crawlers read) stay clean.
 * 2. An unlinked photo is matched by file name against the images of every
 *    product the article links to (/products/<handle>.js, which the buy bar has
 *    usually fetched already). Article photos are mostly product gallery files.
 * 3. No match: the nearest product the article mentions before the photo, else
 *    the first one after it (the hero sits above every mention).
 * An article that links no product is left alone.
 *
 * THE UTM
 * utm_source=houseland_blog & utm_medium=internal & utm_campaign=<article> &
 * utm_content=<hero|img_N|card>. hl-mixpanel.js ignores utm_medium=internal
 * when it labels the channel, so a reader who came from ChatGPT or Google keeps
 * that channel after the tap instead of turning into "Campaign".
 */
(function () {
  if (window.__hlBlogImgPdp) return;
  window.__hlBlogImgPdp = true;

  var m = /^\/blogs\/[^/]+\/([^/?#]+)/.exec(location.pathname);
  if (!m) return;
  var article = m[1];

  var content = document.querySelector('.blog-post-content');
  var root = (content && content.closest('.shopify-section')) || content;
  if (!root) return;

  var PRODUCT_LINK = 'a[href*="/products/"]';
  var SKIP = '.hl-blog-bar, .hl-bb-sheet, .hl-pdpm, header, footer, [data-product-id]';

  function handleOf(href) {
    var h = /\/products\/([a-z0-9][a-z0-9\-]*)/i.exec(href || '');
    return h ? h[1].toLowerCase() : null;
  }

  /* "img_01_primary-kitchen-island_520ede9f-5886-4….jpg?v=1&width=800" and the
     same file at another width must compare equal. Shopify appends a uuid when
     a name collides on upload, so it is cut too. */
  function stem(src) {
    var f = (src || '').split('?')[0].split('/').pop().toLowerCase();
    f = f.replace(/\.(jpe?g|png|webp|gif|avif)$/, '');
    f = f.replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/, '');
    f = f.replace(/_\d+x\d*$/, '');
    return f;
  }

  function withUtm(href, content) {
    var u;
    try { u = new URL(href, location.origin); } catch (e) { return href; }
    if (u.origin !== location.origin) return href;
    u.searchParams.set('utm_source', 'houseland_blog');
    u.searchParams.set('utm_medium', 'internal');
    u.searchParams.set('utm_campaign', article);
    u.searchParams.set('utm_content', content);
    return u.pathname + u.search + u.hash;
  }

  // Products the article links to, in document order.
  var mentions = [];
  var links = root.querySelectorAll(PRODUCT_LINK);
  for (var i = 0; i < links.length; i++) {
    var h = handleOf(links[i].getAttribute('href'));
    if (h) mentions.push({ handle: h, node: links[i] });
  }
  if (!mentions.length) return;

  var handles = [];
  mentions.forEach(function (x) { if (handles.indexOf(x.handle) === -1) handles.push(x.handle); });

  var byStem = {};
  var ready = Promise.all(handles.slice(0, 12).map(function (h) {
    return fetch('/products/' + h + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        (p.images || []).forEach(function (src) {
          var s = stem(src);
          if (s && !byStem[s]) byStem[s] = h;
        });
      })
      .catch(function () {});
  }));

  function nearest(img) {
    var before = null, after = null;
    for (var i = 0; i < mentions.length; i++) {
      var pos = img.compareDocumentPosition(mentions[i].node);
      if (pos & Node.DOCUMENT_POSITION_PRECEDING) before = mentions[i].handle;
      else if (!after && (pos & Node.DOCUMENT_POSITION_FOLLOWING)) after = mentions[i].handle;
    }
    return before || after;
  }

  function track(props) {
    try { if (typeof window.gtag === 'function') window.gtag('event', 'blog_image_click', props); } catch (e) {}
  }

  // The photos this takes over: unlinked ones inside the article section.
  var imgs = root.querySelectorAll('.image-block__image, .blog-post-content img');
  var n = 0;
  Array.prototype.forEach.call(imgs, function (img) {
    if (img.closest(SKIP) || img.closest(PRODUCT_LINK)) return;
    if ((img.naturalWidth && img.naturalWidth < 80) || img.width < 80) return;   // icons, avatars
    var label = img.classList.contains('image-block__image') ? 'hero' : 'img_' + (++n);
    img.setAttribute('data-hl-img-pdp', label);
    img.setAttribute('role', 'link');
    img.setAttribute('tabindex', '0');
    img.style.cursor = 'pointer';

    function go(e) {
      if (e.type === 'keydown' && e.key !== 'Enter') return;
      e.preventDefault();
      /* Visible at once: the reader sees the tap land, and Mixpanel's dead-click
         detector sees the page respond during the wait before navigating. */
      img.setAttribute('aria-busy', 'true');
      img.style.transition = 'opacity .15s';
      img.style.opacity = '.6';
      var fallback = nearest(img);
      /* Wait for the file-name index at most 600ms: the handle from position is
         always available, so a slow fetch costs precision, never the tap. */
      var timeout = new Promise(function (res) { setTimeout(res, 600); });
      Promise.race([ready, timeout]).then(function () {
        var handle = byStem[stem(img.currentSrc || img.src)] || fallback;
        if (!handle) { img.removeAttribute('aria-busy'); img.style.opacity = ''; return; }
        var matched = !!byStem[stem(img.currentSrc || img.src)];
        track({ product_handle: handle, image_slot: label, matched_by: matched ? 'file' : 'position',
                click_source: 'blog_image' });
        var href = withUtm('/products/' + handle, label);
        // A beat for the event to leave; hl-mixpanel also flushes on pagehide.
        setTimeout(function () { location.href = href; }, 120);
      });
    }
    window.addEventListener('pageshow', function () { img.removeAttribute('aria-busy'); img.style.opacity = ''; });
    img.addEventListener('click', go);
    img.addEventListener('keydown', go);
  });

  /* Photos that already link to a product: same UTM, added on the way out.
     Middle-click and cmd-click still work because only the href changes. */
  root.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest(PRODUCT_LINK);
    if (!a || a.closest(SKIP) || !a.querySelector('img')) return;
    if (/[?&]utm_medium=internal/.test(a.getAttribute('href') || '')) return;
    var h = handleOf(a.getAttribute('href'));
    if (!h) return;
    a.setAttribute('href', withUtm(a.getAttribute('href'), 'card'));
    track({ product_handle: h, image_slot: 'card', matched_by: 'link', click_source: 'blog_image' });
  }, true);
})();
